// Generated by purs version 0.15.15
import * as Color from "../Color/index.js";
var toCssStringColor = {
    css: Color.toHexString
};
var css = function (dict) {
    return dict.css;
};
export {
    css,
    toCssStringColor
};
